import styles from './Footer.module.css'

export const Footer = () => {
    return (
        <footer className={styles.footer}>
            <p>Copyright me &copy;</p>
            {/* <p>Thanks for the CSS: Mihail Valkov @ SoftUni | W3 team</p> */}
        </footer>
    );
};
